import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withRoot = getWithRootPathGetter('/resourceservice');

export const resourcesApiPaths = {
  employees: withRoot('/employees'),
  employeeById: withRoot('/employees/:employeeId'),
  csById: withRoot('/employees/:employeeId/clinical-specialist'),
  activateCSById: withRoot('/employees/:employeeId/clinical-specialist/activate'),
  deactivateCSById: withRoot('/employees/:employeeId/clinical-specialist/deactivate'),
  clById: withRoot('/employees/:employeeId/clinical-lead'),
  activateCLById: withRoot('/employees/:employeeId/clinical-lead/activate'),
  deactivateCLById: withRoot('/employees/:employeeId/clinical-lead/deactivate'),
  employeeByUserId: withRoot('/employees/userid/:userId'),
  deactivateEmployeeById: withRoot('/employees/:employeeId/deactivate'),
  activateEmployeeById: withRoot('/employees/:employeeId/activate'),
  csRestPeriodsById: withRoot('/clinical-specialists/rest-periods/:restPeriodId'),
  csRestPeriodsCreate: withRoot('/clinical-specialists/rest-periods/create'),
  csRestPeriodsModify: withRoot('/clinical-specialists/rest-periods/modify'),
  csRestPeriodsCancel: withRoot('/clinical-specialists/rest-periods/cancel'),
  csRestPeriodsDelete: withRoot('/clinical-specialists/rest-periods/delete'),
  rsLiRestPeriodsById: withRoot('/retrieval-surgeons/rest-periods/liver/:restPeriodId'),
  rsLiRestPeriodsCreate: withRoot('/retrieval-surgeons/rest-periods/liver/create'),
  rsLiRestPeriodsModify: withRoot('/retrieval-surgeons/rest-periods/liver/modify'),
  rsLiRestPeriodsCancel: withRoot('/retrieval-surgeons/rest-periods/liver/cancel'),
  rsLiRestPeriodsDelete: withRoot('/retrieval-surgeons/rest-periods/liver/delete'),
  rsHtLuRestPeriodsById: withRoot('/retrieval-surgeons/rest-periods/heart-lungs/:restPeriodId'),
  rsHtLuRestPeriodsCreate: withRoot('/retrieval-surgeons/rest-periods/heart-lungs/create'),
  rsHtLuRestPeriodsModify: withRoot('/retrieval-surgeons/rest-periods/heart-lungs/modify'),
  rsHtLuRestPeriodsCancel: withRoot('/retrieval-surgeons/rest-periods/heart-lungs/cancel'),
  rsHtLuRestPeriodsDelete: withRoot('/retrieval-surgeons/rest-periods/heart-lungs/delete'),
  employeeRestPeriodsCancelMyActive: withRoot('/employees/rest-periods/cancel-my-active'),
  ocsConsoles: withRoot('/ocsconsoles'),
  ocsConsoleById: withRoot('/ocsconsoles/:consoleId'),
  inventory: withRoot('/inventory'),
  copyInventory: withRoot('/inventory/copy'),
  aircrafts: withRoot('/aircrafts'),
  resourcesAvailability: withRoot('/resources/availability'),
  aircraftAvailability: withRoot('/resources/availability/aircrafts'),
  employeeAvailability: withRoot('/resources/availability/employees'),
  ocsDeviceAvailability: withRoot('/resources/availability/ocsconsoles'),
  employeesReservations: withRoot('/resources/reservation/employees'),
  bannedTailNumbers: withRoot('/banned-tail-numbers'),
  bannedTailNumbersById: withRoot('/banned-tail-numbers/:tailNumberId'),
  drivers: withRoot('/drivers'),
  driverById: withRoot('/drivers/:driverId'),
  specialistsForAssignment: withRoot('/assignment-candidates/clinical-specialists'),
  reliefSpecialistsForAssignment: withRoot('/assignment-candidates/relief/clinical-specialists'),
  surgeonsForAssignment: withRoot('/assignment-candidates/retrieval-surgeons'),
  contractorSurgeonsForAssignment: withRoot('/assignment-candidates/retrieval-surgeons-contractors'),
  coordinatorsForAssignment: withRoot('/assignment-candidates/clinical-coordinators'),
  omsForAssignment: withRoot('/assignment-candidates/organ-management-specialists'),
  clinicalLeadsForAssignment: withRoot('/assignment-candidates/clinical-leads'),
} as const;

export const getResourcesApiUrl = {
  employees: () => resourcesApiPaths.employees,
  employeeById: (employeeId: string) => replacePathParams(resourcesApiPaths.employeeById, { employeeId }),
  csById: (employeeId: string) => replacePathParams(resourcesApiPaths.csById, { employeeId }),
  activateCSById: (employeeId: string) => replacePathParams(resourcesApiPaths.activateCSById, { employeeId }),
  deactivateCSById: (employeeId: string) => replacePathParams(resourcesApiPaths.deactivateCSById, { employeeId }),
  clById: (employeeId: string) => replacePathParams(resourcesApiPaths.clById, { employeeId }),
  activateCLById: (employeeId: string) => replacePathParams(resourcesApiPaths.activateCLById, { employeeId }),
  deactivateCLById: (employeeId: string) => replacePathParams(resourcesApiPaths.deactivateCLById, { employeeId }),
  employeeByUserId: (userId: string) => replacePathParams(resourcesApiPaths.employeeByUserId, { userId }),
  deactivateEmployeeById: (employeeId: string) =>
    replacePathParams(resourcesApiPaths.deactivateEmployeeById, { employeeId }),
  activateEmployeeById: (employeeId: string) =>
    replacePathParams(resourcesApiPaths.activateEmployeeById, { employeeId }),
  csRestPeriodsById: (restPeriodId: string) => replacePathParams(resourcesApiPaths.csRestPeriodsById, { restPeriodId }),
  csRestPeriodsCreate: () => resourcesApiPaths.csRestPeriodsCreate,
  csRestPeriodsModify: () => resourcesApiPaths.csRestPeriodsModify,
  csRestPeriodsCancel: () => resourcesApiPaths.csRestPeriodsCancel,
  csRestPeriodsDelete: () => resourcesApiPaths.csRestPeriodsDelete,
  rsLiRestPeriodsById: (restPeriodId: string) =>
    replacePathParams(resourcesApiPaths.rsLiRestPeriodsById, { restPeriodId }),
  rsLiRestPeriodsCreate: () => resourcesApiPaths.rsLiRestPeriodsCreate,
  rsLiRestPeriodsModify: () => resourcesApiPaths.rsLiRestPeriodsModify,
  rsLiRestPeriodsCancel: () => resourcesApiPaths.rsLiRestPeriodsCancel,
  rsLiRestPeriodsDelete: () => resourcesApiPaths.rsLiRestPeriodsDelete,
  rsHtLuRestPeriodsById: (restPeriodId: string) =>
    replacePathParams(resourcesApiPaths.rsHtLuRestPeriodsById, { restPeriodId }),
  rsHtLuRestPeriodsCreate: () => resourcesApiPaths.rsHtLuRestPeriodsCreate,
  rsHtLuRestPeriodsModify: () => resourcesApiPaths.rsHtLuRestPeriodsModify,
  rsHtLuRestPeriodsCancel: () => resourcesApiPaths.rsHtLuRestPeriodsCancel,
  rsHtLuRestPeriodsDelete: () => resourcesApiPaths.rsHtLuRestPeriodsDelete,
  employeeRestPeriodsCancelMyActive: () => resourcesApiPaths.employeeRestPeriodsCancelMyActive,
  ocsConsoles: () => resourcesApiPaths.ocsConsoles,
  ocsConsoleById: (consoleId: string) => replacePathParams(resourcesApiPaths.ocsConsoleById, { consoleId }),
  inventory: () => resourcesApiPaths.inventory,
  copyInventory: () => resourcesApiPaths.copyInventory,
  aircrafts: () => resourcesApiPaths.aircrafts,
  resourcesAvailability: () => resourcesApiPaths.resourcesAvailability,
  aircraftAvailability: () => resourcesApiPaths.aircraftAvailability,
  employeeAvailability: () => resourcesApiPaths.employeeAvailability,
  ocsDeviceAvailability: () => resourcesApiPaths.ocsDeviceAvailability,
  employeesReservations: () => resourcesApiPaths.employeesReservations,
  bannedTailNumbers: () => resourcesApiPaths.bannedTailNumbers,
  bannedTailNumbersById: (tailNumberId: string) =>
    replacePathParams(resourcesApiPaths.bannedTailNumbersById, { tailNumberId }),
  drivers: () => resourcesApiPaths.drivers,
  driverById: (driverId: string) => replacePathParams(resourcesApiPaths.driverById, { driverId }),
  clinicalSpecialistsForAssignment: () => resourcesApiPaths.specialistsForAssignment,
  reliefSpecialistsForAssignment: () => resourcesApiPaths.reliefSpecialistsForAssignment,
  surgeonsForAssignment: () => resourcesApiPaths.surgeonsForAssignment,
  contractorSurgeonsForAssignment: () => resourcesApiPaths.contractorSurgeonsForAssignment,
  coordinatorsForAssignment: () => resourcesApiPaths.coordinatorsForAssignment,
  omsForAssignment: () => resourcesApiPaths.omsForAssignment,
  clinicalLeadsForAssignment: () => resourcesApiPaths.clinicalLeadsForAssignment,
};
